import { API_HOST } from "./config"
export default {
  // ZOOM ROUTES
  ZOOM_CRED: `${API_HOST}front/video/meeting_credentials`
}
